interface InfoModelCommon {
    title: string;
    icon?: InformationsIconEnum | InformationsEnum;
    uppercaseValue?: boolean;
    url?: string;
    key: InformationsEnum;
    extraSeoParams?: TExtraSeoParams;
}

export interface InfoModel extends InfoModelCommon {
    value: string;
}

export interface InfoModelRaw extends InfoModelCommon {
    value?: string | null;
}

type TExtraSeoParams = {
    isFirstFloor?: boolean;
    isLastFloor?: boolean;
    floor?: number;
    land?: number;
}

export type TGenerateSeoUrlParams = {
    informationKey: InformationsEnum | InformationsIconEnum;
    informationValue: string;
    extraSeoParams?: TExtraSeoParams;
};

export const mapToInformations = (
    informationsRaw: InfoModelRaw[],
    params?: { generateUrl?: (params: TGenerateSeoUrlParams) => string }
) => {
    return (informationsRaw.filter(info => Boolean(info.value)) as InfoModel[])
        .map(({ key, value, icon, extraSeoParams, ...other }) => {
            let url: undefined | string;

            /* eslint-disable max-len */
            if (value === 'нет' && key === InformationsEnum.noFurniture) url = params?.generateUrl?.({ informationKey: key, informationValue: value, extraSeoParams });
            if (value !== 'нет') url = params?.generateUrl?.({ informationKey: key, informationValue: value, extraSeoParams });
            if (! url && icon) url = params?.generateUrl?.({ informationKey: icon, informationValue: value, extraSeoParams });
            /* eslint-enable max-len */

            return {
                ...(url && { url }),
                value,
                key,
                icon,
                ...other
            };
        });
};

export enum InformationsEnum {
    // special rooms
    roomCountInfo = 'roomCountInfo',
    roomLivingArea = 'roomLivingArea',

    // flat
    roomsCountInFlat = 'roomsCount',
    totalArea = 'totalArea',
    livingArea = 'livingArea',
    kitchenArea = 'kitchenArea',
    bathroom = 'bathroom',
    bathroomCount = 'bathroomCount',
    apartments = 'apartments',

    // building
    floor = 'floors',
    ceilingHeightM = 'ceilingHeight',
    buildYear = 'buildYear',
    renovationProgram = 'renovationProgram',
    finishQuarter = 'finishQuarter',
    balcony = 'balcony',
    hasLift = 'elevator',
    concierge = 'concierge',
    closedArea = 'closedArea',
    garbage = 'garbage',
    windowsDirection = 'windowsDirection',
    openParking = 'openParking',
    closedParking = 'closedParking',
    undergroundParking = 'undergroundParking',
    parking = 'parking',
    wallsType = 'wallsType',
    renovationType = 'renovationType',
    buildEpoch = 'buildEpoch',
    buildSeries = 'buildSeries',
    buildHeatingType = 'buildHeatingType',

    // special house
    houseArea = 'houseArea',
    houseHeating = 'houseHeating',
    houseHasBathroom = 'houseHasBathroom',
    houseRooms = 'houseRooms',
    houseBuildYear = 'houseBuildYear',
    houseFloors = 'houseFloors',
    houseBathroomLocation = 'houseBathroomLocation',
    land = 'land',
    houseCategory = 'houseCategory',

    // special land
    landArea = 'landArea',
    landStatus = 'landStatus',
    gas = 'gas',
    water = 'water',
    electricity = 'electricity',
    sewerage = 'sewerage',

    // livingFacilities
    hasAirConditioner = 'hasAirConditioner',
    hasDishwasher = 'hasDishwasher',
    hasFridge = 'hasFridge',
    hasFurniture = 'hasFurniture',
    noFurniture = 'noFurniture',
    hasInternet = 'hasInternet',
    hasKitchenFurniture = 'hasKitchenFurniture',
    hasTv = 'hasTv',
    hasWashingMachine = 'hasWashingMachine',

    // rent
    tenants = 'tenants',
    pets = 'pets',
    children = 'children',

    //infrastructureEntities
    kindergarten = 'kindergarten',
    shoppingMall = 'shoppingMall',
    park = 'park',
    fitnessClub = 'fitnessClub',
    goodSchools = 'goodSchools',
    sportsGround = 'sportsGround',

    finishing = 'finishing',
}

// @ts-ignore
export const orderInformations: InformationsEnum[] = Object.keys(InformationsEnum).map(key => InformationsEnum[key]);

export enum InformationsIconEnum {
    bathroomNotCombined = 'bathroomNotCombined',
    bathroomCombined = 'bathroomCombined',
    singleHouse = 'singleHouse',
    partHouse = 'partHouse',
    duplex = 'duplex',
    townhouse = 'townhouse',
    houseBathroomIn = 'houseBathroomIn',
    houseBathroomOut = 'houseBathroomOut',
    monolithWalls = 'monolithWalls',
    brickMonolithWalls = 'brickMonolithWalls',
    brickWalls = 'brickWalls',
    blockWalls = 'blockWalls',
    panelWalls = 'panelWalls',
    woodWalls = 'woodWalls',
    renovationDesign = 'renovationDesign',
    renovationEuro = 'renovationEuro',
    renovationFine = 'renovationFine',
    renovationGood = 'renovationGood',
    renovationNeed = 'renovationNeed',
    renovationPartial = 'renovationPartial',
    renovationPreFine = 'renovationPreFine',
    renovationRough = 'renovationRough',
    landIzhs = 'landIzhs',
    landSntOrDnp = 'landSntOrDnp',
    landLph = 'landLph',
    tertiaryArea = 'tertiaryArea',
    totalArea = 'totalArea',
    generalHas = 'generalHas',
    generalHasNot = 'generalHasNot',
    flat = 'flat',
    floors = 'floors',
    buildYear = 'buildYear',
    renovationProgram = 'renovationProgram',
    sellerOrganizationName = 'sellerOrganizationName',
    buildEpoch = 'buildEpoch',
    buildSeries = 'buildSeries',
    buildHeatingType = 'buildHeatingType',
    finishQuarter = 'finishQuarter'
}

